import ClientShell from "./ClientShell";
import { Hourglass } from "lucide-react";

// Master v5 Prompt 7 — an honest, non-broken destination for sidebar/
// mobile-nav entries whose full page (Presentation, Sessions, Feedback,
// Messages, Files, Presence Lab, Our Work, My Work, Commercial Center,
// Review programme & coach) is a later Prompt's scope. Never a 404,
// never a silently-failing button.
export default function RehearsalRoomComingSoon({ title, testId }) {
  return (
    <ClientShell>
      <div className="max-w-lg" data-testid={testId || "rehearsal-room-coming-soon"}>
        <div className="border border-ink/15 bg-white/40 rounded-lg p-8 text-center">
          <Hourglass size={22} className="text-terracotta mx-auto mb-4" />
          <h1 className="font-serif text-2xl text-ink mb-2">{title}</h1>
          <p className="text-ink-soft">This area is being prepared and will be available soon.</p>
        </div>
      </div>
    </ClientShell>
  );
}
